import { ActivatedRoute } from '@angular/router';

export function routerGetLastChild(route: ActivatedRoute) {
  let current = route;
  while (current.firstChild) {
    current = current.firstChild;
  }
  console.log(current);
  return current;
}
